import { createApiSlice } from 'app/createApiSlice'
import {
  API_DASHBOARD_TRACEABILITY_CONFIG,
  API_DASHBOARD_TRACEABILITY_INVENTORY,
  API_DASHBOARD_TRACEABILITY_INVENTORYV2,
  API_DASHBOARD_TRACEABILITY_SUMMARY,
  API_DASHBOARD_TRACEABILITY_SUMMARYV2,
  API_EVENT,
  API_EVENT_UTILS,
} from 'utils/apiList'

export const dashboardTraceabilityApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'dashboardTraceability/hooks',
  endpoints(builder) {
    return {
      fetchConfigurationTraceability: builder.query({
        query(params) {
          const { month, year } = params || {}
          return {
            url: `${API_DASHBOARD_TRACEABILITY_CONFIG}`,
            params: {
              month,
              year,
            },
          }
        },
      }),
      fetchInventoriesTraceability: builder.query({
        query(params) {
          const { dashboardTraceabilityId, size, page, sortby, sortdir } =
            params || {}
          return {
            url: `${API_DASHBOARD_TRACEABILITY_INVENTORY}`,
            params: {
              dashboardTraceabilityId,
              size,
              page,
              sortby,
              sortdir,
            },
          }
        },
      }),
      fetchSummaryTraceability: builder.query({
        query(params) {
          const { dashboardTraceabilityId, userId } = params || {}
          return {
            url: `${API_DASHBOARD_TRACEABILITY_SUMMARY}`,
            params: {
              dashboardTraceabilityId,
              userId,
            },
          }
        },
      }),
      fetchInventoriesTraceabilityV2: builder.query({
        query(params) {
          const { dashboardTraceabilityId, size, page, sortby, sortdir } =
            params || {}
          return {
            url: API_DASHBOARD_TRACEABILITY_INVENTORYV2,
            params: {
              dashboardTraceabilityId,
              size,
              page,
              sortby,
              sortdir,
            },
          }
        },
      }),
      fetchSummaryTraceabilityV2: builder.query({
        query(params) {
          const { dashboardTraceabilityId, userId } = params || {}
          return {
            url: API_DASHBOARD_TRACEABILITY_SUMMARYV2,
            params: {
              dashboardTraceabilityId,
              userId,
            },
          }
        },
      }),
    }
  },
})

export const {
  useFetchConfigurationTraceabilityQuery,
  useLazyFetchConfigurationTraceabilityQuery,
  useFetchInventoriesTraceabilityQuery,
  useLazyFetchInventoriesTraceabilityQuery,
  useFetchSummaryTraceabilityQuery,
  useLazyFetchSummaryTraceabilityQuery,
  useFetchInventoriesTraceabilityV2Query,
  useLazyFetchInventoriesTraceabilityV2Query,
  useFetchSummaryTraceabilityV2Query,
  useLazyFetchSummaryTraceabilityV2Query,
} = dashboardTraceabilityApiSlice
